export enum PaymentsSuccessCodes {
  WITHDRAW_SUCCESS = 'withdraw_success',
  SCHEDULED_PAYMENT_CANCELLED = 'scheduled_payment_cancelled',
  PAYMENTS_CANCELLED = 'payments_cancelled',
  SUBMIT_WITHDRAWAL_NOTICE = 'submit-withdrawal-notice',
}
